<template>
  <!-- ======= About Us Section ======= -->
  <section id="about" class="about">
    <div class="container">
      <div class="section-title">
        <h2>Profile</h2>
      </div>
      <div class="row">
        <div class="col-lg-6 pt-4 pt-lg-0 order-2 order-lg-1">
          <div>
            <img src="../assets/img/DukePic.png" class="d-block w-50" />
          </div>
          <div class="container"></div>
        </div>
        <div class="col-lg-6 pt-4 pt-lg-0 order-2 order-lg-1">
          <p class="about-name">Tsung-Hung Lin</p>
          <p class="about-research-code">
            (ResearcherID: C-3433-2009, Orcid: 0000-0002-5601-4415)
          </p>
          <p class="about-describe-1">
            He received the Ph.D. degree in Computer Science and Information
            Engineering from the National Chung Cheng University, Taiwan,
            R.O.C..
          </p>
          <br />
          <p class="about-describe-1">
            He joined the faculty of Department of Computer Science and
            Information Engineering at National Chin-Yi University of
            Technology, Taiwan, R.O.C., and has been as a full professor.
          </p>
          <br />
          <p class="about-describe-2">
            His research interests include Cyber Security, Artificial
            Intelligence, Machine Learning, Big Data, Cloud Computing, IoT
            applications, Steganography, Multimedia Security, Wireless Personal
            Area Network, and Wireless Sensor Network.
          </p>
        </div>
      </div>
    </div>
  </section>
  <!-- End About Us Section -->
</template>

<script>
export default {
  name: "curriculemvitae",
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@font-face {
  font-family: "NotoSansTC_Regular";
  src: url("../assets/font/NotoSansTC-Regular.otf") format("truetype");
}
@font-face {
  font-family: "NotoSansTC_Bold";
  src: url("../assets/font/NotoSansTC-Bold.otf") format("truetype");
}

/*--------------------------------------------------------------
# General
--------------------------------------------------------------*/
body {
  font-family: "NotoSansTC_Regular", sans-serif;
  color: #777;
}

a {
  text-decoration: none;
  color: #43aea0;
}

a:hover {
  color: #00d3b8;
  text-decoration: none;
}

h1,
h2,
h3,
h4,
h5,
h6,
.font-primary {
  font-family: "NotoSansTC_Regular", sans-serif;
}

/*--------------------------------------------------------------
# Sections General
--------------------------------------------------------------*/
section {
  padding: 100px;
}
.research-code {
  font-family: "NotoSansTC_Bold";
  color: #0000ff;
  text-align: left;
}
.section-name-CHT {
  text-align: left;
  font-size: 3vh;
}
.section-bg {
  background-color: #f2f9f8;
}

.section-title {
  font-family: "NotoSansTC_Bold";
  text-align: center;
  padding-bottom: 30px;
}
.section-title p {
  margin-bottom: 0;
}

/*--------------------------------------------------------------
# About Us
--------------------------------------------------------------*/
.about-name {
  font-family: "NotoSansTC_Bold";
  font-size: 5vh;
  text-align: left;
}
.about-research-code {
  font-family: "NotoSansTC_Bold";
  color: #1875258d;
  font-size: 2vh;
  text-align: left;
}
.about-describe-1 {
  font-family: "NotoSansTC_Regular";
  font-size: 2vh;
  text-align: left;
  color: #389402f1;
}
.about-describe-2 {
  font-family: "NotoSansTC_Regular";
  font-size: 2vh;
  text-align: left;
  color: #0d8491f1;
}

.about h3 {
  font-weight: 400;
  font-size: 26px;
}
.about ul {
  list-style: none;
  padding: 0;
}
.about ul li {
  padding-bottom: 10px;
}
.about ul i {
  font-size: 22px;
  padding-right: 4px;
  color: #70b9b0;
  line-height: 0;
}
.about p {
  text-align: left;
  margin-bottom: 0;
}
</style>
